/**
 * Outreach Warm-up API.
 */
import api from '../../../api';
import type {
  StartWarmupRequest,
  WarmupJob,
  WarmupJobListResponse,
  WarmupEmailTemplate,
  WarmupEmailTemplateCreate,
  WarmupEmailTemplateUpdate,
  WarmupEmailTemplateListResponse,
  WarmupReplyTemplate,
  WarmupReplyTemplateCreate,
  WarmupReplyTemplateUpdate,
  WarmupReplyTemplateListResponse,
} from '../types';

const PREFIX = '/api/outreach/warmup';

export const outreachWarmupApi = {
  start: async (request: StartWarmupRequest): Promise<WarmupJob> => {
    const { data } = await api.post<WarmupJob>(`${PREFIX}/start`, request);
    return data;
  },

  status: async (jobId: string): Promise<WarmupJob> => {
    const { data } = await api.get<WarmupJob>(`${PREFIX}/status/${jobId}`);
    return data;
  },

  cancel: async (jobId: string): Promise<{ job_id: string; status: string }> => {
    const { data } = await api.post<{ job_id: string; status: string }>(`${PREFIX}/cancel/${jobId}`);
    return data;
  },

  listJobs: async (): Promise<WarmupJobListResponse> => {
    const { data } = await api.get<WarmupJobListResponse>(`${PREFIX}/jobs`);
    return data;
  },

  // ---- Email templates ----
  listTemplates: async (): Promise<WarmupEmailTemplateListResponse> => {
    const { data } = await api.get<WarmupEmailTemplateListResponse>(`${PREFIX}/templates`);
    return data;
  },

  createTemplate: async (payload: WarmupEmailTemplateCreate): Promise<WarmupEmailTemplate> => {
    const { data } = await api.post<WarmupEmailTemplate>(`${PREFIX}/templates`, payload);
    return data;
  },

  updateTemplate: async (id: string, payload: WarmupEmailTemplateUpdate): Promise<WarmupEmailTemplate> => {
    const { data } = await api.patch<WarmupEmailTemplate>(`${PREFIX}/templates/${id}`, payload);
    return data;
  },

  deleteTemplate: async (id: string): Promise<void> => {
    await api.delete(`${PREFIX}/templates/${id}`);
  },

  // ---- Reply templates ----
  listReplyTemplates: async (): Promise<WarmupReplyTemplateListResponse> => {
    const { data } = await api.get<WarmupReplyTemplateListResponse>(`${PREFIX}/reply-templates`);
    return data;
  },

  createReplyTemplate: async (payload: WarmupReplyTemplateCreate): Promise<WarmupReplyTemplate> => {
    const { data } = await api.post<WarmupReplyTemplate>(`${PREFIX}/reply-templates`, payload);
    return data;
  },

  updateReplyTemplate: async (id: string, payload: WarmupReplyTemplateUpdate): Promise<WarmupReplyTemplate> => {
    const { data } = await api.patch<WarmupReplyTemplate>(`${PREFIX}/reply-templates/${id}`, payload);
    return data;
  },

  deleteReplyTemplate: async (id: string): Promise<void> => {
    await api.delete(`${PREFIX}/reply-templates/${id}`);
  },
};
